"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseConfig = void 0;
var shared_1 = require("@cian/peperrors/shared");
var matcher_1 = require("../matcher");
var BaseConfig = /** @class */ (function () {
    function BaseConfig(_a) {
        var source = _a.source, matcher = _a.matcher, transformer = _a.transformer;
        this.sources = Array.isArray(source) ? source : [source];
        this.matcher = matcher || new matcher_1.Matcher();
        this.transformer = transformer;
    }
    BaseConfig.prototype.get = function (key, context) {
        var setting = this.find(key, context);
        return setting && setting.value;
    };
    BaseConfig.prototype.getStrict = function (key, context) {
        if (!this.has(key, context)) {
            throw new shared_1.NotFoundError({
                message: "Setting '" + key + "' is missing in the config!",
                domain: 'config.getStrict',
            });
        }
        return this.get(key, context);
    };
    BaseConfig.prototype.has = function (key, context) {
        var selected = this.selectAndFilterBy(key, context);
        return selected.length > 0;
    };
    BaseConfig.prototype.dump = function (keys) {
        var _this = this;
        if (!keys) {
            return this.selectBy();
        }
        var dumpKeys = Array.isArray(keys) ? keys : [keys];
        return dumpKeys.reduce(function (results, key) {
            return __spread(results, _this.selectBy(key));
        }, []);
    };
    BaseConfig.prototype.dumpForContext = function (keys, context) {
        var _this = this;
        var dumpKeys = Array.isArray(keys) ? keys : [keys];
        return dumpKeys.map(function (key) { return _this.find(key, context); }).filter(function (entry) { return entry !== null; });
    };
    BaseConfig.prototype.find = function (key, context) {
        var selected = this.selectAndFilterBy(key, context);
        var setting = selected.reduce(function (top, current) {
            if (!top) {
                return current;
            }
            return current.priority > top.priority ? current : top;
        }, null);
        return this.settingTransform(setting);
    };
    BaseConfig.prototype.selectAndFilterBy = function (key, context) {
        var _this = this;
        var selected = this.selectBy(key);
        return selected.filter(function (setting) { return _this.matcher.matches(setting, context); });
    };
    BaseConfig.prototype.settingTransform = function (setting) {
        if (!this.transformer || !setting) {
            return setting;
        }
        return this.transformer.transform(setting);
    };
    BaseConfig.prototype.selectBy = function (key) {
        return this.sources.reduce(function (results, source) {
            return __spread(results, source.select(key));
        }, []);
    };
    return BaseConfig;
}());
exports.BaseConfig = BaseConfig;
//# sourceMappingURL=baseConfig.js.map